import type { AssignPaymentToInvoiceResponse, AssignPaymentToInvoiceRequestPayload } from '@vy/api-definition';
import { AssignPaymentToInvoiceResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateInvoicesQueries, invalidatePaymentsQueries } from '../../utils/query-invalidation';

type AssignPaymentToInvoiceVariables = {
  paymentId: string;
  invoiceId: string;
};

export function useAssignPaymentToInvoice(
  options?: UseMutationOptions<AssignPaymentToInvoiceResponse, unknown, AssignPaymentToInvoiceVariables>,
) {
  const queryClient = useQueryClient();

  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation({
    mutationFn: async ({ paymentId, invoiceId }: AssignPaymentToInvoiceVariables) => {
      const api = getPrivateApi();
      const assignPaymentToInvoiceRequest: AssignPaymentToInvoiceRequestPayload = { invoiceId };
      const response = await api.assignPaymentToInvoice({ paymentId, assignPaymentToInvoiceRequest });

      return AssignPaymentToInvoiceResponseSchema.parse(response);
    },
    onSuccess: async (data, variables, context) => {
      await Promise.all([
        invalidateInvoicesQueries(queryClient),
        invalidatePaymentsQueries(queryClient),
      ]);

      await onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
}
